export const IMG = {
  hero: "https://customer-assets.emergentagent.com/job_5ddde511-583b-412d-8b5b-3d24dc330039/artifacts/6hmq7nyq_Muenz5%20FINAL.jpg",
  hands: "https://customer-assets.emergentagent.com/job_5ddde511-583b-412d-8b5b-3d24dc330039/artifacts/lejsrulz_Muenz19%20FINAL.jpg",
  leading: "https://customer-assets.emergentagent.com/job_5ddde511-583b-412d-8b5b-3d24dc330039/artifacts/av4im96k_Muenz20%20FINAL.jpg",
  meditation: "https://customer-assets.emergentagent.com/job_5ddde511-583b-412d-8b5b-3d24dc330039/artifacts/jnlb3n1k_Muenz7%20FINAL.jpg",
  ritual: "https://customer-assets.emergentagent.com/job_5ddde511-583b-412d-8b5b-3d24dc330039/artifacts/fmzvo0nd_Muenz37%20FINAL.jpg",
  bioWarm: "https://customer-assets.emergentagent.com/job_goldmine-memorial/artifacts/gb78pyal_Muenz55%20FINAL.jpg",
  modalities: "https://customer-assets.emergentagent.com/job_goldmine-memorial/artifacts/w1afh21k_Muenz76%20FINAL.jpg",
  closingGroup: "https://customer-assets.emergentagent.com/job_goldmine-memorial/artifacts/glc282am_Muenz9%20FINAL.jpg",
  modalitiesGroup: "https://customer-assets.emergentagent.com/job_goldmine-memorial/artifacts/ir7jynm0_Muenz64%20FINAL.jpg",
};

// Price doubles at end-of-day July 31 (next upcoming July 31 from now)
const _closeDate = (() => {
  const now = new Date();
  const year = now.getMonth() > 6 || (now.getMonth() === 6 && now.getDate() > 31)
    ? now.getFullYear() + 1
    : now.getFullYear();
  return new Date(year, 6, 31, 23, 59, 59, 999); // month 6 = July
})();

export const CLOSE_DATE = _closeDate;

export const CHECKOUT_URL = "https://wealth.jmuenz.com/the-goldmine-audio/";
